import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';

const SignupButton = (_ref) => {
  let {
    trackingUrl,
    trackingIdentifier,
    variant = 'secondary',
    children,
    postSignupRedirect
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["trackingUrl", "trackingIdentifier", "variant", "children", "postSignupRedirect"]);

  const location = window.location;
  const params = {
    'hubs_signup-url': trackingUrl || location.href,
    'hubs_signup-cta': trackingIdentifier || null
  };

  if (postSignupRedirect) {
    params.intent = postSignupRedirect;
  }

  const queryString = stringify(params);
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsx(CUIButton, Object.assign({
    onClick: () => trackInteraction('signup button click', {
      identifier: trackingIdentifier
    }),
    as: "a",
    variant: variant,
    href: `${getFullUrl('app')}/signup-hubspot/connect?${queryString}`
  }, rest, {
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connect.signupCta"
    })
  }));
};

export default SignupButton;